<template>
  <div class="app page-login flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <form @submit.prevent="login">
            <div class="opening-message">
              <img
                class="logo"
                src="static/img/leakcentral_horizontal.svg"
                alt="Leak Central logo"
              >
              <p>To login, enter your username and password.</p>
              <p>You will also need your authenticator app to enter a security passcode.</p>
            </div>
            <div class="input-group mb-3">
              <input
                v-model="username"
                type="text"
                class="form-control login"
                required
                placeholder="Username"
              >
            </div>
            <div class="input-group mb-4">
              <input
                v-model="password"
                type="password"
                class="form-control login"
                required
                placeholder="Password"
              >
            </div>
            <button
              type="submit"
              class="btn btn-primary px-4 login"
            >
              Login
            </button>
            <div class="row center-block">
              <button
                type="button"
                class="btn btn-link ssoLogin"
                @click="loginWithSSO"
              >
                <div class="ssoLogin">
                  Login with SSO
                </div>
              </button>
              
              <button
                type="button"
                class="btn btn-link forgotP"
                @click="myModal = true"
              >
                <div class="forgotP">
                  Forgotten your password?
                </div>
              </button>
            </div>
            <!-- errors -->
            <div
              v-if="errLogin"
              class="text-red loginError"
            >
              <span class="errorImg"><img
                src="static/img/error.svg"
                alt="login error"
              ></span>
              <span class="errLogin">{{ errLogin }}</span>
            </div>
          </form>
          <!-- Modal -->
          <b-modal
            v-if="myModal"
            v-model="myModal"
            class="aligned"
            title="Reset Password"
            hide-footer
            @ok="myModal = false"
          >
            Forgot your password? No problem. Just enter your email below and we'll send a you a link to reset it.
            <form @submit.prevent="resetPassword">
              <div class="resetModal">
                <input
                  v-model="username"
                  type="text"
                  class="form-control login"
                  required
                  placeholder="Email Address"
                >
              </div>
              <button
                type="submit"
                class="btn btn-primary login center-block modalSubmit"
              >
                Submit
              </button>
            </form>
          </b-modal>
          <!--Modal-->
        </div>
      </div>
    </div>
    <footer class="login-footer">
      <img
        src="static/img/labs_logo.svg"
        class="labs-logo center-block"
        alt="labs-img"
      >
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/event-bus.js'
import * as Routes from '../constants/routes'
import { APIEvent } from '../events/apiEvent'

export default {
  showModal: false,
  name: 'Login',
  data () {
    return {
      myModal: false,
      setup2fa: false,
      enterOTP: false,
      section: 'Login',
      loading: '',
      username: '',
      password: '',
      response: '',
      errLogin: '',
      inputOTP: '',
      error: ''
    }
  },
  computed: {
    ...mapGetters([
      'otp'
    ])
  },
  watch: {
    loginOTP: function (newValue, oldValue) {
      // apply your logic here, e.g. invoke your listener function
      console.log('was: ', oldValue, ' now: ', newValue)
    },
    loginError: function (newValue, oldValue) {
      console.log('was: ', oldValue, ' now: ', newValue)
    }
  },
  mounted () {
    EventBus.$on('login-error', errLogin => {
      this.errLogin = errLogin
      this.username = ''
      // this.$router.push(Routes.LOGIN)
    })
    
    // Listen for SSO errors from EventBus
    EventBus.$on('sso-error', errorMessage => {
      this.errLogin = errorMessage
    })
    
    // Check for SSO error in URL query parameters
    if (this.$route.query.error === 'sso_failed') {
      this.errLogin = 'SSO login failed. Please try again or contact your administrator if the issue persists.'
      // Clean up the URL - remove query parameters
      this.$router.replace({ path: '/login' })
    }
  },
  beforeDestroy () {
    // Clean up event listeners
    EventBus.$off('login-error')
    EventBus.$off('sso-error')
  },
  methods: {
    close: function () {
      this.username = ''
    },
    resetPassword (event) {
      const {username} = this
      this.$store.dispatch(APIEvent.RESET_PWD, username)
        .then(() => {
          this.myModal = false
          this.close()
          this.$router.push(Routes.RESET_PWD_CONF)
        })
        .catch((error) => {
          this.errLogin = error.message
        })
    },
    login: function () {
      const { username, password } = this
      this.errLogin = ''
      var options = {}
      if (this.$route !== undefined && this.$route.params !== undefined && this.$route.params.dynamics !== undefined) {
        options = { username, password, 'dynamics': 'yes' }
        this.$store.commit('dynamicsLogin', 'yes')
      } else {
        options = { username, password, 'dynamics': 'no' }
        this.$store.commit('dynamicsLoginRemoved')
        this.$store.commit('dynamicsLogin', 'no')
      }

      // console.log(options)
      this.$store.dispatch(APIEvent.LOGIN, options)
        .then(() => {
          if (!this.$store.state.loggedInStatus) {
            this.error = true
          } else {
            this.$router.push(this.$route.query.redirect || Routes.HOME)
          }
        })
        .catch((error) => {
          this.errLogin = error.message
        })
    },
    
    toggleLoading () {
      this.loading = (this.loading === '') ? 'loading' : ''
    },
    
    resetResponse () {
      this.response = ''
    },

    loginWithSSO () {
      const targetPath = (this.$route.query.redirect || Routes.HOME);
      
      // Clear any previous errors
      this.errLogin = '';

      this.$store.dispatch(APIEvent.SSO_LOGIN, {
        targetPath
      }).catch(error => {
        console.error('SSO login error:', error);
        this.errLogin = 'SSO login failed. Please try again or contact your administrator if the issue persists.';
      });
    }
  }
}
</script>

<style lang="css">
  .labs-logo {
    width: 7.5% !important;
    height: 7.5% !important;
  }
</style>
